const FIELD_LABELS = Object.freeze({
  name: 'bot name',
  template_name: 'Stock Focus',
  risk_budget_pct: 'maximum allocation',
  symbols: 'selected stocks',
  trading_strategy_slug: 'trading strategy',
  strategy_definition_id: 'trading strategy',
  stock_selection_mode: 'stock selection',
  stock_focus_selection: 'Stock Focus selection',
});

const validationMessage = (detail) => {
  if (!Array.isArray(detail)) return null;
  const issue = detail.find((item) => item && typeof item === 'object'
    && typeof item.msg === 'string' && item.msg.trim());
  if (!issue) return null;

  const location = Array.isArray(issue.loc) ? issue.loc : [];
  const field = location.find((value) => typeof value === 'string' && value !== 'body');
  const label = FIELD_LABELS[field] || 'bot setup';
  // FastAPI/Pydantic validation messages are generated from our request model.
  // Keep the response bounded so a malformed upstream response cannot become UI copy.
  const message = issue.msg.trim().slice(0, 180);
  return `Check ${label}: ${message}.`;
};

export const customerBotCreationError = (detail, fallback) => {
  const validation = validationMessage(detail);
  if (validation) return validation;
  if (typeof detail === 'string') return fallback;
  if (!detail || typeof detail !== 'object') return fallback;
  const symbols = Array.isArray(detail.details?.symbols)
    ? detail.details.symbols.filter((symbol) => typeof symbol === 'string')
    : [];
  const reasonMessages = detail.details?.reason_messages;
  const explanations = symbols
    .map((symbol) => (
      typeof reasonMessages?.[symbol] === 'string'
        ? `${symbol}: ${reasonMessages[symbol]}`
        : null
    ))
    .filter(Boolean);
  if (explanations.length) {
    return `${explanations.join(' ')} Choose compatible replacements before creating the bot.`;
  }
  return `${detail.message || fallback}${symbols.length ? ` Affected stocks: ${symbols.join(', ')}.` : ''}`;
};

export const isBotStructuralEligibilityError = (detail) => Boolean(
  detail
  && typeof detail === 'object'
  && ['preset_symbol_unsupported', 'bot_symbol_unsupported'].includes(detail.code)
  && Array.isArray(detail.details?.symbols)
  && detail.details.symbols.length,
);
